module.exports = __webpack_public_path__ + "img/img-74.e8db2540.png";